import { Link } from "react-router";
import styled from "styled-components";
import { MessageScreen } from "../components/MessageScreen";
import { actionButtonStyles } from "../styles/actionButton";

export function NotFound() {
  return (
    <MessageScreen
      title="Page not found"
      message="The page you are looking for does not exist or has moved."
    >
      <HomeLink to="/">Back to Progress</HomeLink>
    </MessageScreen>
  );
}

const HomeLink = styled(Link)(actionButtonStyles);
